/* eslint-env jquery */
import { header } from '../scripts';
const $ = jQuery;
const contactTOC = $('.contact-table-of-contents');
if ($('body').hasClass('page-contact-us')) {
  contactToC();
}

function contactToC() {
  $('main').css('overflow', 'unset');
  const siteFooter = $('footer');
  $('.progress-line').css('height', '15px');
  $('.toc-menu').find('li:first').addClass('active');
  const tocContents = contactTOC.html();
  if (contactTOC.length > 0) {
    $('.toc-mobile').append(`<div class="contact-table-of-contents">${tocContents}</div>`);
  }

  const contactTOCmobile = $('.toc-mobile .contact-table-of-contents');
  contactTOCmobile.css('height', 0);
  $(document).on('click', '.toc-mobile li a', () => {
    $('.toc-mobile').find('.contact-table-of-contents').animate(
      {
        height: 0
      },
      100
    );
    $('body').removeClass('toc-lock');
    $('.toc-mobile').removeClass('toc-active');
  });
  $(document).on('click', '.toc-mobile-trigger', function () {
    $(this).parent().toggleClass('toc-active');
    $('body').toggleClass('toc-lock');
    if ($('.toc-mobile').hasClass('toc-active')) {
      $(this)
        .parent()
        .find('.contact-table-of-contents')
        .animate(
          {
            height: $('.toc-mobile .contact-table-of-contents').get(0).scrollHeight
          },
          200,
          function () {
            $(this).height('auto');
          }
        );
    } else {
      $(this).parent().find('.contact-table-of-contents').animate(
        {
          height: 0
        },
        100
      );
    }
  });
  $(window).scroll(() => {
    const windowPos = $(window).scrollTop();
    const windowHeight = $(window).height();

    if (windowPos + windowHeight < siteFooter.offset().top) {
      $('.link-tiles-container')
        .children()
        .each(function () {
          const section = $(this);
          const sectionID = $(this).attr('id');
          if (sectionID) {
            const selector = `.toc-menu > li > a[href="#${sectionID}"]`;
            if (
              $(selector).length > 0 &&
              windowPos + 2 >= section.offset().top - header.outerHeight() - 150
            ) {
              // 2 value is a buffer to trigger it 2pixels earlier
              $('.toc-menu li').removeClass('active');
              $('.toc-menu li').find(`a[href="#${sectionID}"]`).parent().addClass('active');
              const toc = $('.toc-desktop');
              const containerPos = toc.find('.toc-menu').offset().top;
              let activeMenuPos = toc.find('.toc-menu li.active');
              if (activeMenuPos.length > 0) {
                activeMenuPos = activeMenuPos.offset().top;
              }

              const finalmenuPos = activeMenuPos - containerPos + 15;
              $('.toc-menu').find('.progress-line').css('height', `${finalmenuPos}px`);
              $('.toc-menu li.active').prev('li').addClass('passed');
              $('.toc-menu li.active').next('li').removeClass('passed');
            }
          }
        });
      if ($('.toc-menu li.active').is(':last-child')) {
        $('.toc-menu').addClass('last-elem-active');
      } else {
        $('.toc-menu').removeClass('last-elem-active');
      }
    }
  });
}
